import {
	resetDeletedObstructionIDs,
	setDrawModeState,
	setEnableObsMode,
	toggleAddObstructionsMode,
	toggleDeleteFacetsMode,
	toggleDeleteObstructionsMode,
} from 'store/slices/ToolSlice';
import {
	setEnableFacetEdit
} from 'store/slices/RoofEditSlice';
import {
	setAddPanel,
	setDeleteIndividualPanelsMode,
	setPanelMove
} from 'store/slices/PanelSlice';
import { toogleTreeEditingMode } from 'store/slices/TreeSlice';
import { getSelectedFacets, TOOL_ACTION } from 'store/selectors/toolSelector';
import { AppDispatch, store } from 'store';
import { enableRoofToolLines } from 'store/slices/RoofToolLinesSlice';

export const enableAction = (dispatch: AppDispatch, action: TOOL_ACTION) => {
	const map: Partial<Record<TOOL_ACTION, () => void>> = {
		[TOOL_ACTION.DRAW_FACET]: () => dispatch(setDrawModeState({ enabled: true })),
		[TOOL_ACTION.EDIT_FACET]: () => dispatch(setEnableFacetEdit({ isEnable: true })),
		[TOOL_ACTION.DELETE_FACET]: () => dispatch(toggleDeleteFacetsMode({ enable: true })),
		[TOOL_ACTION.EDIT_OBSTRUCTION]: () => { dispatch(setEnableObsMode({ enable: true }));
			dispatch(resetDeletedObstructionIDs());},
		[TOOL_ACTION.ADD_PANEL]: () => dispatch(setAddPanel({ shouldEnable: true })),
		[TOOL_ACTION.MOVE_PANEL]: () => dispatch(setPanelMove({ shouldEnablePanelMove: true })),
		[TOOL_ACTION.DELETE_PANEL]: () => dispatch(setDeleteIndividualPanelsMode({ enabled: true })),
		[TOOL_ACTION.EDIT_EDGES]: () => dispatch(enableRoofToolLines({ shouldEnable: true, initialData: getSelectedFacets(store.getState())})),
		[TOOL_ACTION.EDIT_TREE]: () => dispatch(toogleTreeEditingMode(true)),
	};

	map[action]?.();
};

export const disableAction = (dispatch: AppDispatch, action: TOOL_ACTION) => {
	const map: Partial<Record<TOOL_ACTION, () => void>> = {
		[TOOL_ACTION.DRAW_FACET]: () => dispatch(setDrawModeState({ enabled: false })),
		[TOOL_ACTION.EDIT_FACET]: () => dispatch(setEnableFacetEdit({ isEnable: false })),
		[TOOL_ACTION.DELETE_FACET]: () => dispatch(toggleDeleteFacetsMode({ enable: false })),
		[TOOL_ACTION.EDIT_OBSTRUCTION]: () => dispatch(setEnableObsMode({ enable: false })),
		[TOOL_ACTION.ADD_PANEL]: () => dispatch(setAddPanel({ shouldEnable: false })),
		[TOOL_ACTION.MOVE_PANEL]: () => dispatch(setPanelMove({ shouldEnablePanelMove: false })),
		[TOOL_ACTION.DELETE_PANEL]: () => dispatch(setDeleteIndividualPanelsMode({ enabled: false })),
		[TOOL_ACTION.EDIT_TREE]: () => dispatch(toogleTreeEditingMode(false)),
	};

	map[action]?.();
};
